var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCodeicon = function SvgCodeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.89 1.62.77.3h-.03c.2.07.31.3.24.5L6.62 14.14a.4.4 0 0 1-.5.24l-.76-.27a.4.4 0 0 1-.24-.51L9.37 1.86c.08-.2.3-.3.52-.24ZM1.86 8.01l2.76-2.75a.4.4 0 0 0 0-.56l-.57-.56a.4.4 0 0 0-.57 0l-3.3 3.3a.61.61 0 0 0-.18.42v.3c0 .16.06.31.18.42l3.3 3.3a.4.4 0 0 0 .58 0l.56-.56a.4.4 0 0 0 0-.57L1.86 8.01ZM16 8.16c0 .16-.06.31-.18.42l-3.3 3.3a.4.4 0 0 1-.58 0l-.56-.57a.4.4 0 0 1 0-.56l2.76-2.74-2.76-2.75a.4.4 0 0 1 0-.56l.56-.56a.4.4 0 0 1 .57 0l3.31 3.3a.6.6 0 0 1 .18.42v.3Z",
    clipRule: "evenodd"
  })));
};
export default SvgCodeicon;